// extracted by mini-css-extract-plugin
export default {"main":"CommonHero_main__2mTQK","shopHero":"CommonHero_shopHero__JxQP6","inner":"CommonHero_inner__AX5MT","contentCont":"CommonHero_contentCont__lMUUw"};